module.exports = __webpack_public_path__ + "static/media/4.af4fbf41.jpg";